import { requestApi } from '../util/network'

export const arriveStore =
(order_id) =>
  requestApi(
    '/o2o_distributor_order/arrive_store',
    'POST',
    {
      'order_id': order_id
    },
    'distributor'
  )

// 取货
export const pickupOrder =
(orderId) =>
  requestApi(
    '/o2o_distributor_order/pickup_order',
    'POST',
    {
      'order_id': orderId
    },
    'distributor'
  )

export const receiveOrder =
(order_id, o2o_order_receive_code) =>
  requestApi(
    '/o2o_distributor_order/receive_order',
    'POST',
    {
      'o2o_order_receive_code': o2o_order_receive_code,
      'order_id': order_id
    },
    'distributor'
  )

export const getOrderList =
(params, type, other) =>
  requestApi(
    '/o2o_distributor_order/get_list',
    'POST',
    Object.assign(
      {
          'page': params.page,
          'per_page': params.per_page,
        'type': type
      },
      other),
    'distributor'
  )

export const getOrderInfo =
(order_id) =>
  requestApi(
    '/o2o_distributor_order/get_info',
    'POST',
    {
      'order_id': order_id
    },
    'distributor'
  )

export const getMixOrders =
(params) => requestApi(
    '/distributor_mix_order/index',
    'GET',
    params,
    'distributor'
)

export const reportPaymentAmount = (params) => {
	const form = new FormData()
	for (const [key, value] of Object.entries(params)) {
		if (key === 'images') {
			value.forEach((v, index) => {
				form.append('images[]', v.file)
			})
		} else {
			form.append(key, value)
		}
	}
	return requestApi(
		'/o2oDistributorOrder/reportPaymentAmount',
		'POST',
		form,
		'distributor',
		true
	)
}
